import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import { useAuth } from "../login/AuthProvider";
import { member_search, member_edit, file_upload } from '../../components/apipath';
import SwitchBox from "../../components/switchBox";
import {switchHelper, dateHelper, textHelper} from "../../modules/helpers";
import PageList from "../../components/pageList";


function AdmMemberView() {
    const [memberlist, setMemberlist] = useState([]);
    const [conditions, setConditions] = useState(null);
    const [rowsCount, setRowsCount] = useState(1); // 暫存資料總筆數
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const { token } = useAuth();
    const memberStatus = ['請選擇', '在職者', "在學生", "全職考生", "待業中"];
    const memberAccountStatus = ['請選擇', '停用', '啟用'];
    const userTypes = ['請選擇', 'CPA', 'CMA'];
    const products = ['請選擇', '菁英方案', '全修方案', '選修方案', '自修方案', '單科雙語'];
    
    const thisYear = new Date(Date.now()).getFullYear();
    const yearList = (thisYear) => {
        let years = [];
        for(let i = thisYear; i >= 2020; i--){
            years.push(i);
        }
        return years;
    }

    const initSearchForm = async () => {
        setConditions({
            year: thisYear,
            product_id: null,
            user_type: null,
            pass: null,
            refund: null,
            chinese_name: null,
            account_status: null,
            mem_status: null,
        });
    }

    useEffect(()=>{
        initSearchForm();
    }, []);

    const fetchData = async (page=1, rows=50) => {
        try {
            setLoading(true); // 開始加載
            if (page-1 <= 0) page = 1;
            let postData = conditions;
            for(let key in postData){
                if (!postData[key])
                    postData[key] = null;
            }
            const response = await axios.post(`${member_search(page-1, rows)}`, conditions, {headers:{token: token}});
            setMemberlist(response.data[0].data);
            setRowsCount(response.data[1].data[0].total); 
            setLoading(false); // 完成加載
        } catch (error) {
            console.error('Error:', error);
            setLoading(false);
        }
    };

    

    const handleInputChange = (e) => {
        const { name, value, checked, type } = e.target;
        if (['checkbox'].includes(type)){
            setConditions({
                ...conditions,
                [name]: switchHelper(checked),
            });
        } else {
            setConditions({
                ...conditions,
                [name]: value,
            });
        }
    };

    const handleSearch = (e) => {
        fetchData();
    }


    return (
        <>
            <div className="container-fluid p-5 mt-5">
                {conditions && (
                    <>
                        <div className="row g-2">
                            <div className="col-xl-2 col-md-3 col-4">
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">年度</span>
                                    <select 
                                        className="form-select form-select-sm"
                                        name="year"
                                        value={textHelper(conditions.year)}
                                        onChange={handleInputChange}
                                    >
                                        {yearList(thisYear).map((value)=>(
                                            <option key={value} value={value}>{value}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="col-xl-2 col-md-3 col-4">
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">方案</span>
                                    <select 
                                        className="form-select form-select-sm"
                                        name="product_id"
                                        value={textHelper(conditions.product_id)}
                                        onChange={handleInputChange}
                                    >
                                        {products.map((value, index)=>(
                                            <option key={index} value={ index === 0 ? "" : index }>{value}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="col-xl-2 col-md-3 col-4">
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">科目</span>
                                    <select 
                                        className="form-select form-select-sm"
                                        name="user_type"
                                        value={textHelper(conditions.user_type)}
                                        onChange={handleInputChange}
                                    >
                                        {userTypes.map((value, index)=>(
                                            <option key={index} value={ index === 0 ? "" : value }>{value}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="col-xl-2 col-md-3 col-4">
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">狀態</span>
                                    <select 
                                        className="form-select form-select-sm"
                                        name="status"
                                        value={textHelper(conditions.status)}
                                        onChange={handleInputChange}
                                    >
                                        {memberStatus.map((value, index)=>(
                                            <option key={index} value={ index === 0 ? "" : index }>{value}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="col-xl-2 col-md-3 col-4">
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">帳戶狀態</span>
                                    <select 
                                        className="form-select form-select-sm"
                                        name="account_status"
                                        value={textHelper(conditions.account_status)}
                                        onChange={handleInputChange}
                                    >
                                        {memberAccountStatus.map((value, index)=>(
                                            <option key={index-1} value={ index === 0 ? "" : index-1 }>{value}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="col-xl-3 col-md-4 col-12">
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">學員搜尋</span>
                                    <input 
                                    type="text" 
                                    className="form-control form-control-sm" 
                                    placeholder="搜尋" 
                                    aria-label="Chinese_Name" 
                                    aria-describedby="addon-wrapping" 
                                    maxLength={200}
                                    name="chinese_name"
                                    value={textHelper(conditions.chinese_name)}
                                    onChange={handleInputChange} />
                                </div>
                            </div>
                            <div className="col-xl-1 col-md-2 col-4">
                                <div className="input-group input-group-sm">
                                    {SwitchBox('pass', conditions.pass, handleInputChange, "已通過")}
                                </div>
                            </div>
                            <div className="col-xl-1 col-md-2 col-4">
                                <div className="input-group input-group-sm">
                                    {SwitchBox('refund', conditions.refund, handleInputChange, "已退費")}
                                </div>
                            </div>
                            {/* <div className="col-xl-1 col-md-2 col-4">
                                <div className="input-group input-group-sm">
                                    {SwitchBox('postpone', conditions.postpone, handleInputChange, "展延")}
                                </div>
                            </div> */}
                            <div className="col-xl-1 col-md-2 col-4">
                                <div className="input-group input-group-sm">
                                    {SwitchBox('mem_status', conditions.mem_status, handleInputChange, "學員")}
                                </div>
                            </div>
                            <div className="col-xl-6 col-md-10 col-12 text-xl-end text-md-end text-sm-center">
                                <button className="btn btn-primary btn-sm" onClick={handleSearch}>搜尋</button>
                            </div>
                        </div>
                    </>
                )}
                <div className="mt-2 table-responsive">
                    <table className="table table-striped border table-hover">
                        <thead>
                            <tr>
                                <td>姓名</td>
                                <td>狀態</td>
                                <td>帳號</td>
                                <td>手機</td>
                                <td>信箱</td>
                                <td>創建日期</td>
                                <td>功能</td>
                                <td>編輯</td>
                            </tr>
                        </thead>
                        <tbody>
                            {memberlist && memberlist.map((member)=>(
                                member.mem_id ? (
                                <tr key={member.mem_id ?? -1 }>
                                    <td>{member.chinese_name}</td>
                                    <td>
                                        {memberStatus[member.status]}
                                    </td>
                                    <td>
                                        {member.account}
                                    </td>
                                    <td>
                                        {member.phone_num}
                                    </td>
                                    <td>
                                        {member.email}
                                    </td>
                                    <td>
                                        {dateHelper(member.createtime, 'date')}
                                    </td>
                                    <td>
                                        <div className="g-2">
                                            <a href={`${file_upload}member/${member.mem_id}/mResume`} target="_blank" rel="noreferrer" className="btn btn-secondary btn-sm m-1 p-1">履歷</a>
                                            <a href={`${file_upload}member/${member.mem_id}/mTranscript`} target="_blank" rel="noreferrer" className="btn btn-secondary btn-sm m-1 p-1">成績單</a>
                                            <a href={`${file_upload}member/${member.mem_id}/mInterview`} target="_blank" rel="noreferrer" className="btn btn-secondary btn-sm m-1 p-1">諮詢紀錄</a>
                                            <a href={`${file_upload}member/${member.mem_id}/mApplication`} target="_blank" rel="noreferrer" className="btn btn-secondary btn-sm m-1 p-1">報考文件</a>
                                            <a href={`${file_upload}member/${member.mem_id}/mAcademic`} target="_blank" rel="noreferrer" className="btn btn-secondary btn-sm m-1 p-1">學歷認證</a>
                                        </div>
                                    </td>
                                    <td>
                                        <a className="btn btn-primary btn-sm" target="_blank" href={member_edit + member.mem_id} rel="noreferrer">編輯</a>
                                    </td>
                                    <td></td>
                                </tr>
                            ) : <></>))}
                        </tbody>
                    </table>
                </div>
                <div className="m-2 p-2">
                    {PageList(rowsCount, fetchData)}
                </div>
            </div>
        </>
    );
}
export default AdmMemberView;